<div id="blog" class="blog-area">
  <div class="container">
    <div class="section-title">
      <h2>Últimas <span>Noticias</span></h2>
      <p>Aquí vemos una recopilación de las últimas noticias en las que nos mencionan</p>
    </div>
    <div class="blog-carousel" aria-label="Últimas noticias">
      <div class="blog-track">
        @for (copy of [0, 1]; track copy) {
          <div class="blog-group" [attr.aria-hidden]="copy === 1">
            @for (news of newsItems; track news) {
              <a class="single-blog-item"
                [class.single-blog-item--with-cover]="news.coverUrl"
                [href]="news.link"
                target="_blank"
                rel="noopener noreferrer"
                [attr.aria-label]="'Abrir noticia: ' + news.title"
                [attr.tabindex]="copy === 1 ? -1 : null">
                @if (news.coverUrl) {
                  <img class="news-cover" [src]="news.coverUrl" [alt]="news.title">
                }
                <h3>{{ news.title }}</h3>
                <p class="news-source">{{ news.fuente }}</p>
                <time class="news-date" [attr.datetime]="news.fecha">{{ formatDate(news.fecha) }}</time>
                <span class="link-btn" aria-hidden="true">
                  <i class="fas fa-arrow-right"></i>
                </span>
              </a>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
